import classNames from 'classnames';
import { useTranslations } from 'utils';

function RecurringPaymentDisclaimer({ className }: { className?: string }) {
  const i18n = useTranslations();
  return (
    <div
      className={classNames(
        'flex items-center gap-2.5 rounded border bg-gray-200 p-3 text-xs',
        className,
      )}
    >
      <div className="inline-flex items-center rounded-sm bg-blue-600 px-1.5 py-0.5 font-medium uppercase text-white ring-1 ring-blue-600">
        {i18n.t('paymentInformation.itemSelection.recurring.disclaimer.label')}
      </div>
      <div className="text-gray-700">
        {i18n.t('paymentInformation.itemSelection.recurring.disclaimer.body')}
      </div>
    </div>
  );
}

export { RecurringPaymentDisclaimer };
